import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  DashboardWidgetCostBreakdown,
  DashboardWidgetCostBreakdownRequest,
} from "@/services/cloudchipr.api";
import { billingExplorerWidgetByIdSelector } from "@/store/dashboards/selectors/widgets/billing-explorer-widget/widget-view/billingExplorerWidgetByIdSelector";
import { RootState } from "@/store/store";
import { updateWidgetThunk } from "@/store/dashboards/thunks/widgets/common/updateWidgetThunk";

import { openWidgetBuildingSnackbar } from "@/store/dashboards/thunks/widgets/utils/openWidgetBuildingSnackbar";
import { enqueueSnackbarErrorAlert } from "@/components/pages/common/snackbar-alert/EnqueueSnackbarErrorAlert";
import { UpdateDashboardWidgetRequestType } from "@/store/dashboards/utils/types/types";
import { getBillingExplorerWidgetDataByWidgetIdThunk } from "@/store/dashboards/thunks/widgets/billing-explorer-widget/getBillingExplorerWidgetDataByWidgetIdThunk";
import { updateExplainWithAiSliceBuWidgetIdThunk } from "@/store/explain-with-ai/thunks/updateExplainWithAiSliceBuWidgetIdThunk";

export const updateBillingExplorerWidgetFromQuickActionsThunk =
  createAsyncThunk(
    "dashboards/editBillingExplorerWidget",
    async (
      updatedWidget: Partial<DashboardWidgetCostBreakdown>,
      { dispatch, getState },
    ) => {
      const state = getState() as RootState;

      if (!updatedWidget.id) {
        return;
      }

      const widget = billingExplorerWidgetByIdSelector(state, updatedWidget.id);

      const updateWidgetArguments: DashboardWidgetCostBreakdownRequest = {
        name: updatedWidget.name ?? widget?.name ?? "",
        view_id: updatedWidget.view_id ?? widget?.view_id ?? "",
        grouping: updatedWidget.grouping ?? widget?.grouping,
        group_values: updatedWidget.group_values ?? widget?.group_values,
        type: "cost_breakdown",
        date_granularity:
          updatedWidget.date_granularity ?? widget?.date_granularity,
        //TODO: EnableWidgetsSideBarConfigurations, remove chart_type
        chart_type:
          updatedWidget.visualization?.chart_type ??
          widget?.visualization?.chart_type ??
          "stacked_column",
        visualization: updatedWidget.visualization ?? widget?.visualization,
        aggregation: updatedWidget.aggregation ?? widget?.aggregation,
        layout: widget?.layout,
        forecast_option:
          updatedWidget.forecast_option ?? widget?.forecast_option,
        dates: updatedWidget.dates ?? widget?.dates,
        trend_type: updatedWidget.trend_type ?? widget?.trend_type,
        inherit_dates: updatedWidget.inherit_dates ?? widget?.inherit_dates,
      };

      try {
        const response = await dispatch(
          updateWidgetThunk({
            widget: updateWidgetArguments as UpdateDashboardWidgetRequestType,
            widgetId: updatedWidget.id,
          }),
        ).unwrap();

        if (response) {
          openWidgetBuildingSnackbar("cost_breakdown", "update");
        }

        if (response) {
          await dispatch(
            getBillingExplorerWidgetDataByWidgetIdThunk({
              widgetId: response.id,
              forceRefetch: true,
            }),
          );
          dispatch(updateExplainWithAiSliceBuWidgetIdThunk(updatedWidget.id));
        }
      } catch (e) {
        // @ts-expect-error todo: fix api spec;
        enqueueSnackbarErrorAlert(e?.data?.message);
      }
    },
  );
